import React from 'react';
import './Page.css';

function About() {
  return (
    <div className="App">
      <div className="header">
        <h1>About Emoji Postcard</h1>
      </div>

      <div className="card">
        <div className="page-content">
          <h2>The Story Behind Emoji Postcard</h2>
          <p>
            I needed a fast, no-hassle way to send thank you cards or cryptic messages to friends.
            Nothing existed that was simple enough, so I built this. All proceeds support the developer's hobbies.
          </p>
          <p>
            Thank you for using Emoji Postcard!
          </p>

          <h3>How It Works</h3>
          <p>
            Pick an emoji, write a message (or don't), and we'll mail it. Thousands of emojis available.
            No return address—keep them guessing who sent it. And no, we won't sell your personal information.
          </p>

          <h3>Quality & Delivery</h3>
          <p>
            Each postcard is professionally printed on high-quality cardstock and mailed via
            USPS First Class Mail. Delivery typically takes 5-7 business days within the
            United States.
          </p>

          <p>
            Here's an example of what your emoji postcard will look like when it arrives.
            Each card features a vibrant, high-resolution emoji on the front with your personalized
            message on the back—professionally printed and ready to brighten someone's mailbox.
          </p>

          <div className="mockup-container">
            <img
              src={process.env.PUBLIC_URL + '/mockup.png'}
              alt="Emoji postcard example"
              className="mockup-image"
            />
          </div>

          <h3>Availability</h3>
          <p>
            Currently, Emoji Postcard is only available for delivery within the United States.
            We're working on bringing the joy (and mischief) to more countries soon!
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
